import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["disableTarget"];

  toggle(_event) {
    this.disableTargetTargets.forEach((el) => this.#setDisabled(el, !this.#isDisabled(el)));
  }

  disable(_event) {
    this.disableTargetTargets.forEach((el) => this.#setDisabled(el, true));
  }

  enable(_event) {
    this.disableTargetTargets.forEach((el) => this.#setDisabled(el, false));
  }

  #isDisabled(element) {
    if ("disabled" in element) return Boolean(element.disabled);
    return element.getAttribute("aria-disabled") === "true";
  }

  #setDisabled(element, isDisabled) {
    if ("disabled" in element) {
      element.disabled = isDisabled;
    }
    element.setAttribute("aria-disabled", String(isDisabled));
  }
}

